

<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="Autoship" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { AutoshipProps } from './Autoship.ts';
import Autoship from './Autoship.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-autoship';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<AutoshipProps>();
const changableProps = useChangableProps(componentName, props);

</script>
